import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let user_id = useDataValue({
    context: 'auth',
    path: 'access_token_data.user_id',
    viewPath: props.viewPath,
  })
  let xid = useDataValue({
    context: 'selected',
    path: 'xid',
    viewPath: props.viewPath,
  })
  let division_id = useDataValue({
    context: 'selected',
    path: 'division_id',
    viewPath: props.viewPath,
  })

  return useMemo(
    () => ({
      variables: {
        xid,
        user_id,
        organization_filter: division_id
          ? {
              parent: { _id: { _eq: division_id } },
            }
          : {},
      },
      context: {
        fetchOptions: {
          headers: {
            'x-hasura-role': 'app-admin-xid',
          },
        },
      },
      pause: !xid,
    }),
    [division_id, user_id, xid]
  )
}
